import React, { lazy } from 'react'
import Header from '../../../@core/layouts/components/Header/Header';
// import MainCarousel from '../../../components/LandingPageComponents/MainCarousel/MainCarousel';
// import FlashSale from '../../../components/LandingPageComponents/FlashSale/FlashSale';
// import ShopByCategory from '../../../components/LandingPageComponents/ShopByCategory/ShopByCategory';
// import TrendingSales from '../../../components/LandingPageComponents/TrendingSales/TrendingSales';
// import FilteredProducts from '../../../components/LandingPageComponents/FilteredProducts/FilteredProducts';
// import RecommendedProducts from '../../../components/LandingPageComponents/RecommendedProducts/RecommendedProducts';
// import PreFooter from '../../../@core/layouts/components/landing/PreFooter';
// import NewsLetter from '../../../@core/layouts/components/newsletter/NewsLetter';
const MainCarousel = lazy(() => import('../../../components/LandingPageComponents/MainCarousel/MainCarousel'))
const FlashSale = lazy(() => import('../../../components/LandingPageComponents/FlashSale/FlashSale'))
const ShopByCategory = lazy(() => import('../../../components/LandingPageComponents/ShopByCategory/ShopByCategory'))
const TrendingSales = lazy(() => import('../../../components/LandingPageComponents/TrendingSales/TrendingSales'))
const FilteredProducts = lazy(() => import('../../../components/LandingPageComponents/FilteredProducts/FilteredProducts'))
const RecommendedProducts = lazy(() => import('../../../components/LandingPageComponents/RecommendedProducts/RecommendedProducts'))
const PreFooter = lazy(() => import('../../../@core/layouts/components/landing/PreFooter'))
const NewsLetter = lazy(() => import('../../../@core/layouts/components/newsletter/NewsLetter'))

import { useSelector } from 'react-redux';

const MainLandingPage = () => {

  return (
    <div className='bg-white'>
        {/* <Header /> */}
        <MainCarousel/>
        <FlashSale />
        <ShopByCategory />
        <TrendingSales />
        <FilteredProducts />
        <RecommendedProducts />
        <PreFooter />
        <NewsLetter />
    </div>
  )
}

export default MainLandingPage;